/**
 * Despacha al componente TestRun correcto según el parámetro :type de la URL.
 * Cada tipo tiene su propio componente con la mecánica exacta del ASP.NET original.
 */
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { TYPE_TO_API_PATH } from '../api/client';
import { SpeedContext } from './tests/shared/TestLayout';
import TestRunLibreTest from './tests/TestRunLibreTest';
import TestRunRotacion from './tests/TestRunRotacion';
import TestRunPriming from './tests/TestRunPriming';
import TestRunMemoria from './tests/TestRunMemoria';
import TestRunDigitos from './tests/TestRunDigitos';
import TestRunAprendizaje from './tests/TestRunAprendizaje';

const COMPONENTS = {
  libretest: TestRunLibreTest,
  rotacion: TestRunRotacion,
  priming: TestRunPriming,
  memoriaacortopalabras: TestRunMemoria,
  digitosdirectosinversos: TestRunDigitos,
  aprendizajesuperficialprofundo: TestRunAprendizaje,
};

export default function TestRunDispatcher() {
  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const isTest = searchParams.get('test') === '1';
  const [fastMode, setFastMode] = useState(isTest);
  const speedMultiplier = fastMode ? 10 : 1;

  const apiType = TYPE_TO_API_PATH[type] ?? type;
  const Component = COMPONENTS[apiType];

  if (!Component) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <p className="text-red-600">Tipo de test desconocido: {type}</p>
      </div>
    );
  }

  return (
    <SpeedContext.Provider value={{ speedMultiplier, isTest, fastMode, setFastMode }}>
      <Component />
    </SpeedContext.Provider>
  );
}
